@import 'apps/webcomponents/src/assets/style-helpers.scss';
@import 'apps/webcomponents/src/assets/common.scss';

.wrapper {
  width: 100%;
  height: 100%;
  padding-top: calc(var(--spacer) * 2);
  display: block;

  .content-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;

    .form-wrapper {
      min-width: 500px;
      width: 100%;
      height: 100%;
      overflow-y: auto;

      padding-left: calc(var(--spacer) * 4);
      padding-right: var(--spacer);
    }

    .bottom-buttons {
      width: 100%;
      flex-basis: 65px;
      min-height: 65px;
      margin-top: auto;
      display: flex;
      align-items: center;

      border-top: 1px solid var(--grey-layout-chart-100);

      padding-left: calc(var(--spacer) * 4);
      padding-right: calc(var(--spacer) * 4);

      gz-button {
        margin-right: calc(var(--spacer) * 2);
      }

      .flex-auto {
        flex: auto;
      }
    }
  }

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .content-wrapper {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }

  #done-button {
    display: none;
  }
}
